import React from "react";
import {Route} from "react-router-dom";

import CompanyUserIndex from "./index";

const data = [<Route exact key="CompanyUserIndex" path="/company/user/index" element={<CompanyUserIndex />} />];

export default data;
